// extracted by mini-css-extract-plugin
module.exports = {"sidebar-layout-wrapper":"SideBarLayout_sidebar-layout-wrapper__SBIJQ"};